import { Chart, Interaction, registerables } from 'chart.js';
import { getZoomFactor } from './zoomPopper';

// Register standard Chart.js elements and plugins
Chart.register(...registerables);

/**
 * Global Chart.js plugin to correct event coordinates when CSS zoom is applied to html.
 */
export const zoomChartPlugin = {
  id: 'zoomChartFix',
  beforeEvent(chart: any, args: any) {
    const zoom = getZoomFactor();
    if (zoom !== 1 && args?.event) {
      if (typeof args.event.x === 'number' && !(args.event as any)._zoomFixed) {
        args.event.x /= zoom;
        (args.event as any)._zoomFixed = true;
      }
      if (typeof args.event.y === 'number' && !(args.event as any)._zoomFixedY) {
        args.event.y /= zoom;
        (args.event as any)._zoomFixedY = true;
      }
      if (typeof chart.isPointInArea === 'function') {
        args.inChartArea = chart.isPointInArea(args.event);
      }
    }
  },
};

Chart.register(zoomChartPlugin);

/**
 * Wrap all Chart.js Interaction modes (index, dataset, point, nearest, x, y)
 * to ensure all hover and tooltip targets are accurately resolved under CSS zoom.
 */
try {
  if (Interaction && Interaction.modes) {
    const modesObj = Interaction.modes as Record<string, any>;
    Object.keys(modesObj).forEach(mode => {
      const origMode = modesObj[mode];
      if (origMode && !origMode._isZoomWrapped) {
        const wrappedMode = function (chart: any, e: any, options: any, useFinalPosition: any) {
          const zoom = getZoomFactor();
          let eventToUse = e;
          if (zoom !== 1 && e && typeof e.x === 'number' && !(e as any)._zoomFixed) {
            eventToUse = {
              ...e,
              x: e.x / zoom,
              y: typeof e.y === 'number' ? e.y / zoom : e.y,
              _zoomFixed: true,
            };
          }
          return origMode.call(this, chart, eventToUse, options, useFinalPosition);
        };
        wrappedMode._isZoomWrapped = true;
        modesObj[mode] = wrappedMode;
      }
    });
  }
} catch {
  // Ignore if Interaction.modes is immutable in specific bundle environments
}

export const initZoomChart = (): void => {
  // Module load executes registration
};
